import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const ContactImage = () => {
  const data = useStaticQuery(query)

  return (
    <div>
      <Img
        fluid={data.placeholderImage.childImageSharp.fluid}
        alt="Contact Footer Image"
      />
    </div>
  )
}

const query = graphql`
  query {
    placeholderImage: file(relativePath: { eq: "contact/contact-01.png" }) {
      childImageSharp {
        fluid(maxWidth: 131) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

export default ContactImage
